import { useEffect, useState } from "react";
import Lenis from "lenis";
import axios from "axios";
import { Toaster } from "sonner";
import Nav from "../components/site/Nav";
import Hero from "../components/site/Hero";
import Marquee from "../components/site/Marquee";
import { About, Why, Process, SoundSupport, Venues } from "../components/site/Sections";
import Services from "../components/site/Services";
import Members from "../components/site/Members";
import Videos from "../components/site/Videos";
import Concert from "../components/site/Concert";
import Gallery from "../components/site/Gallery";
import Booking from "../components/site/Booking";
import Faq from "../components/site/Faq";
import { Contact, Footer, MobileBar } from "../components/site/Contact";
import { scrollToId } from "../lib/scroll";
import { API, MEMBERS_DEFAULT, FAQS_DEFAULT } from "../lib/site";

const VENUES_FALLBACK = [
  "DSOI, Sector 36, Chandigarh",
  "Chandigarh Golf Club",
  "Elite private social gatherings",
  "Old age homes",
  "Senior citizen meets",
].map((name) => ({ name }));

export default function Home() {
  const [content, setContent] = useState({});
  const [presetType, setPresetType] = useState("");

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    axios.get(`${API}/content`).then((r) => setContent(r.data || {})).catch(() => {});
  }, []);

  const enquire = (type) => {
    setPresetType(type);
    scrollToId("#book");
  };

  return (
    <div className="min-h-screen bg-navy-950" data-testid="home-page">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Why />
        <Services onEnquire={enquire} />
        <Members members={content.members?.length ? content.members : MEMBERS_DEFAULT} />
        <Videos videos={content.videos || []} />
        <Venues venues={content.venues?.length ? content.venues : VENUES_FALLBACK} />
        <Concert concert={content.concert} />
        <Process />
        <SoundSupport />
        <Gallery gallery={content.gallery || []} />
        <Booking presetType={presetType} />
        <Faq faqs={content.faqs?.length ? content.faqs : FAQS_DEFAULT} />
        <Contact />
      </main>
      <Footer />
      <MobileBar />
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}
